import { ButtonProps } from '@mui/material';

const colors = {
  accentColor: '#2F9C95',
  accentColor10: 'rgba(47, 156, 149, 0.1)',
  accentColor20: 'rgba(47, 156, 149, 0.2)',
  accentColorDark: '#26847E',
  accentColorLight: '#5DB5B0',
  alpha50: 'rgba(23, 33, 43, 0.5)',
  bg: '#FFFFFF',
  bgDark: 'rgba(227, 230, 233, 0.75)',
  black: '#17212B',
  blue: '#17212B',
  blueDark: '#0F161D',
  blueLight: '#E8F4F3',
  brandingBg: '#FEFBF8',
  dark: '#17212B',
  divider: '#A8ADB3',
  emails: {
    email: 'rgb(240, 243, 246)',
    emailHover: 'rgba(217, 226, 233, 0.3)',
    emailSelected: 'rgb(224, 231, 238)',
    thread: '#FFFFFF',
    threadHover: 'rgba(234, 236, 238, 0.2)',
    threadSelected: 'rgb(240, 243, 246)',
  },
  green: '#8BC34A',
  greenDark: '#6E9B38',
  greenLight: '#F0F7E4',
  grey: '#A8ADB3',
  greyDark: '#5C6670',
  greyDarker: '#17212B',
  greyLight: '#D5D9DC',
  orange: '#F2A541',
  orangeDark: '#D88E2E',
  purple: '#801EFF',
  purpleLight: '#aa6afd',
  red: '#BD2832',
  redDark: '#a20c16',
  redLight: '#FDECEA',
  stroke: '#E2E6E9',
  stroke20: 'rgba(226, 230, 233, 0.2)',
  stroke40: 'rgba(226, 230, 233, 0.4)',
  stroke60: 'rgba(226, 230, 233, 0.6)',
  turquoise: '#2F9C95',
  turquoiseDark: '#26847E',
  white: '#FFFFFF',
  yellow: '#F2A541',
} as const;

export const themeColors: typeof colors & Record<Required<ButtonProps>['color'], string> = {
  ...colors,
  error: colors.red,
  info: colors.grey,
  inherit: colors.accentColor,
  primary: colors.accentColor,
  secondary: colors.blue,
  success: colors.green,
  warning: colors.orange,
};
